<template>
    <div>
        <div class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 d-flex">
                <div>
                    {{ currentPreviewString }}
                </div>
                <div
                    v-if="recipientUpdated"
                    class="ms-2 text-bubble-info">
                    {{ updatedBadgeText }}
                </div>
            </div>
            <pc-button
                v-if="recipientUpdated"
                class="p-0 ms-3"
                link
                v-on:click="toggleUpdatedView">
                {{ buttonText }}
            </pc-button>
        </div>
        <pc-transition transition="slide">
            <div
                v-if="showOldValues"
                class="d-flex mt-1">
                <div class="fst-italic">
                    {{ originalPreviewString }}
                </div>
                <div class="ms-2 text-bubble-info">
                    {{ contactInfoPreviewOriginalBadge }}
                </div>
            </div>
        </pc-transition>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "ESignatures/ManageRequest/i18n/manageRequestContactInfo.i18n";
    import { ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE } from "ESignatures/EditEnvelope/editEnvelopeStore";

    export default {
        props: {
            recipient: { type: Object, required: true },
            // Component assumes this is the correct definition for this recipient
            recipientDefinition: { type: Object, required: true },
            currentContactInfo: { type: Object, required: true },
            updatedContactInfo: { type: Object, required: false, default: null }
        },
        data() {
            return {
                showOldValues: false
            };
        },
        computed: {
            recipientUpdated() {
                return this.originalPreviewString !== this.currentPreviewString;
            },
            buttonText() {
                return this.showOldValues ? this.hideLinkLabel : this.showOriginalContactInfoLinkLabel;
            },
            hasManualUpdatedContactInfo() {
                return Boolean(this.updatedContactInfo);
            },
            currentPreviewString() {
                const contactInfoObj = this.hasManualUpdatedContactInfo
                    ? this.updatedContactInfo
                    : this.currentContactInfo;

                let email = "";
                const firstName = contactInfoObj.first || this.recipient.FirstName;
                const lastName = contactInfoObj.last || this.recipient.LastName;
                const fullName = this.fullName(firstName, lastName);

                //Don't show emails for recipients selected via user selector
                if (this.recipientDefinition.ContactInfoType == ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE.UserField) {
                    return fullName;
                }
                email = contactInfoObj.email || this.recipient.Email;
                return this.formatString(fullName, email);
            },
            originalPreviewString() {
                const fullName = this.fullName(this.recipient.FirstName, this.recipient.LastName);
                //Don't show emails for recipients selected via user selector
                if (this.recipientDefinition.ContactInfoType == ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE.UserField) {
                    return fullName;
                }
                return this.formatString(fullName, this.recipient.Email);
            },
            updatedBadgeText() {
                return this.hasManualUpdatedContactInfo
                    ? this.contactInfoPreviewManuallyUpdatedBadge
                    : this.contactInfoPreviewUpdatedBadge;
            },
            ...mapI18n({ ...KEYS }, NAMESPACE)
        },
        methods: {
            fullName(firstName, lastName) {
                return `${firstName} ${lastName}`;
            },
            formatString(fullName, email) {
                return `${fullName} | ${email}`;
            },
            toggleUpdatedView() {
                this.showOldValues = !this.showOldValues;
            }
        }
    };
</script>
